import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/circuit_game_bg.png';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #111111;
	transition: opacity 0.3s ease;

	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledBackgroundImage = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 1;
	width: 100%;
	height: 630px;
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
`;

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
`;

const StyledContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 630px;
	margin-top: 50px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledTimer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	margin-top: 15px;
	padding: 0 5px;
	background-color: #ffffff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

export {
	StyledWrapper,
	StyledContainer,
	StyledBackground,
	StyledBackgroundImage,
	StyledTimer,
};
